import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { MonthNames } from '../enums/months.enum';
import { EnumTranslationModel } from '../models/display-value.model';

class EnumUtilService {
  public static Months: EnumTranslationModel[];

  public static getEnumValues(enumType: any): string[] {
    if (!Object.values(enumType).length) {
      throw new Error('Invalid enum type provided.');
    }
    return Object.values(enumType);
  }
}

export default EnumUtilService;

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  public initializeEnums() {
    EnumUtilService.Months = [
      {
        value: MonthNames.Januari,
        label: of('Januari'),
      },
      {
        value: MonthNames.Februari,
        label: of('Februari'),
      },
      {
        value: MonthNames.Maart,
        label: of('Maart'),
      },
      {
        value: MonthNames.April,
        label: of('April'),
      },
      {
        value: MonthNames.Mei,
        label: of('Mei'),
      },
      {
        value: MonthNames.Juni,
        label: of('Juni'),
      },
      {
        value: MonthNames.Juli,
        label: of('Juli'),
      },
      {
        value: MonthNames.Augustus,
        label: of('Augustus'),
      },
      {
        value: MonthNames.September,
        label: of('September'),
      },
      {
        value: MonthNames.Oktober,
        label: of('Oktober'),
      },
      {
        value: MonthNames.November,
        label: of('November'),
      },
      {
        value: MonthNames.December,
        label: of('December'),
      },
    ];
  }
}
